(function () {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
    const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv', 'webm'];

    const getFileType = (url) => {
        if (imageExtensions.some(ext => url.includes(ext))) return 'img';
        if (videoExtensions.some(ext => url.includes(ext))) return 'video';
        return 'unknown';
    };

    const createElementAndDownload = (type, src, downloadName, parentElement) => {
        const element = document.createElement(type);
        element.src = src;

        const eventType = type === "img" ? "load" : "loadedmetadata";
        element.addEventListener(eventType, () => {
            const a = document.createElement("a");
            a.href = element.src;
            a.download = downloadName;
            a.click();

            parentElement.classList.remove("loading");
        });
    };

    const handleDownloads = (anchor) => {
        anchor.addEventListener("click", (e) => {
                if( sessionStorage.getItem('isLoged') == 'true' ){
                e.preventDefault();
    
                const fileType = getFileType(anchor.href);
                if (fileType === "unknown") return;
    
                anchor.parentElement.classList.add("loading");
    
                const src = `${site_url}ajax/functions.php?operation=downloadFile&url=${anchor.href}`;
                createElementAndDownload(fileType, src, anchor.download, anchor.parentElement);
            }
        });
    };

    for (const item of document.getElementsByClassName("js-brand-pics")) {
        const gallery = item.dataset.gallery;
        const tabs = item.getElementsByClassName("js-brand-pics-tabs")[0];
        const pics = item.getElementsByClassName("js-brand-picture");
        const picsParent = item.getElementsByTagName("article")[0];
        const breadcrumb = item.getElementsByClassName("js-brand-pics-breadcrumb")[0];
        const anchors = item.querySelectorAll("a[download]");

        anchors.forEach(anchor => handleDownloads(anchor));

        let prevTab;

        const togglePics = (tag) => {
            for (const pic of pics) {
                if( tag == 'All' ){
                    pic.removeAttribute("hidden");
                    pic.firstElementChild.dataset.fancybox = `gallery-${gallery}`;
                    breadcrumb.querySelectorAll(`a.visit_website`).forEach( anchor => anchor.classList.add('hidden'));
                }else if (tag) {
                    pic.toggleAttribute("hidden", !pic.dataset.tag.includes(tag));
                    pic.firstElementChild.dataset.fancybox = `gallery-${gallery}-${tag.replace(/\s+/g, '-')}`;
                } else {
                    pic.removeAttribute("hidden");
                    pic.firstElementChild.dataset.fancybox = `gallery-${gallery}`;
                }
            }
        };

        tabs && tabs.addEventListener("click", (e) => {
            const tab = e.target;

            if (tab.nodeName !== "BUTTON") return;            

            if (prevTab === tab) {
                prevTab.classList.toggle("active");
            } else {
                if (prevTab) prevTab.classList.remove("active");
                tab.classList.add("active");
                prevTab = tab;
            }

            picsParent.classList.remove("fade-in");

            picsParent.addEventListener("transitionend", () => {
                togglePics(tab.classList.contains("active") ? tab.dataset.tag : null);
                let filterUsed = picsParent.previousElementSibling;
                
                if( filterUsed.querySelector(`.visit_website[data-index="${tab.dataset.index}"]`) ){
                    filterUsed.querySelectorAll(`.visit_website`).forEach( anchor => anchor.classList.add('hidden') );
                    filterUsed.querySelector(`.visit_website[data-index="${tab.dataset.index}"] span`).textContent = `Visit ${tab.dataset.tag} Page`;
                    filterUsed.querySelector(`.visit_website[data-index="${tab.dataset.index}"]`).classList.remove('hidden');
                    filterUsed.classList.add('filter-active');
                }else{
                    filterUsed.querySelectorAll(`.visit_website`).forEach( anchor => anchor.classList.add('hidden') );
                    filterUsed.classList.remove('filter-active');
                }

                /*if (!tab.classList.contains("active")) {
                    breadcrumb.querySelector('.tag-indicator').textContent = '';
                } else if (tab.dataset.isSub) {
                    breadcrumb.querySelector('.tag-indicator').innerHTML = `${tab.closest("ul").previousElementSibling.dataset.tag} <span>${tab.dataset.tag}</span>`;
                } else {
                    breadcrumb.querySelector('.tag-indicator').textContent = tab.dataset.tag;
                    if( breadcrumb.querySelector(`a.visit_website[data-index="${tab.dataset.index}"]`) ){
                        breadcrumb.querySelectorAll(`a.visit_website`).forEach( anchor => anchor.classList.add('hidden') );
                        breadcrumb.querySelector(`a.visit_website[data-index="${tab.dataset.index}"]`).classList.remove('hidden');
                    }
                }*/

                picsParent.classList.add("fade-in");
            }, { once: true });
        });
    }
})();
